import { match } from "ts-pattern";

export type PromptType =
  | "GENERATE_SHORT_SUMMARY"
  | "CLASSIFY_VOC"
  | "GENERATE_CATEGORIES"
  | "GENARATE_CATEGORY_SUMMARY";

export type PromptLabel = "default" | "category" | "problem";

export class Prompt {
  constructor(
    public readonly id: string,
    public readonly type: PromptType,
    public readonly label: PromptLabel,
    public readonly content: string,
    public readonly requiredVariables: string[],
  ) {}

  get name(): string {
    return match({ type: this.type, label: this.label })
      .with({ type: "GENERATE_SHORT_SUMMARY" }, () => "ショートサマリー")
      .with(
        { type: "CLASSIFY_VOC", label: "category" },
        () => "既存カテゴリ分類",
      )
      .with({ type: "CLASSIFY_VOC", label: "problem" }, () => "既存課題分類")
      .with(
        { type: "GENERATE_CATEGORIES", label: "category" },
        () => "カテゴリ新規生成・分類",
      )
      .with(
        { type: "GENERATE_CATEGORIES", label: "problem" },
        () => "課題新規生成・分類",
      )
      .with(
        { type: "GENARATE_CATEGORY_SUMMARY", label: "category" },
        () => "カテゴリ要約生成",
      )
      .with(
        { type: "GENARATE_CATEGORY_SUMMARY", label: "problem" },
        () => "課題詳細・打ち手生成",
      )
      .otherwise(() => {
        throw new Error("Unknown prompt type");
      });
  }
}
